import { Navigate, useLocation } from 'react-router-dom';
import { LEGACY_REDIRECT_MAP, LEGACY_PREFIX_MAP } from '../../routes/workspaces';

export default function LegacyRedirect() {
  const location = useLocation();
  const path = location.pathname;

  const exact = LEGACY_REDIRECT_MAP[path];
  if (exact) return <Navigate to={exact} replace />;

  for (const { prefix, replace } of LEGACY_PREFIX_MAP) {
    if (path.startsWith(prefix)) {
      return <Navigate to={path.replace(prefix, replace)} replace />;
    }
  }

  if (path.startsWith('/market/')) {
    return <Navigate to={path.replace('/market/', '/public/')} replace />;
  }
  if (path.startsWith('/portfolio/')) {
    return <Navigate to={path.replace('/portfolio/', '/public/portfolio/')} replace />;
  }
  if (path.startsWith('/institutional/')) {
    return <Navigate to={path.replace('/institutional/', '/private/')} replace />;
  }

  return <Navigate to="/public/analyzer" replace />;
}
